export const common = {
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    pricing: 'Precios',
    faqs: 'FAQs',
    contact: 'Contacto',
    customSolutions: 'Soluciones a medida',
    demo: 'Demo'
  },
  footer: {
    description: 'Automatización e IA para negocios de servicios',
    quickLinks: 'Enlaces rápidos',
    legal: 'Legal',
    legalNotice: 'Aviso Legal',
    privacy: 'Privacidad',
    cookies: 'Cookies',
    contact: 'Contacto',
    email: 'info@velxia.es',
    rights: '© 2026 VELXIA. Todos los derechos reservados.'
  },
  cta: {
    learnMore: 'Saber más',
    getStarted: 'Comenzar',
    contact: 'Contactar',
    backHome: 'Volver al inicio',
    bookDemo: 'Reservar demo',
    requestDemo: 'Solicitar demo',
    send: 'Enviar',
    requestInfo: 'Solicitar información'
  },
  form: {
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    company: 'Empresa',
    message: 'Mensaje',
    optional: '(opcional)',
    response24h: 'Te respondemos en menos de 24 horas'
  },
  backToHome: 'Volver al inicio'
};
